import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import Scanlines from '../components/Scanlines';
import { masteringInfo } from '../mock';

const Mastering = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <Scanlines />
      
      <button onClick={() => navigate('/')} className="back-button">
        <ArrowLeft size={20} />
        <span>BACK</span>
      </button>

      <div className="page-content mastering-content">
        <h1 className="page-title-simple">{masteringInfo.title}</h1>
        
        <p className="mastering-description">{masteringInfo.description}</p>
        
        <div className="mastering-services">
          <h3 className="services-title">SERVICES</h3>
          <ul className="services-list">
            {masteringInfo.services.map((service, index) => (
              <li key={index} className="service-item">
                <span className="service-bullet">→</span>
                {service}
              </li>
            ))}
          </ul>
        </div>

        <a href={`mailto:${masteringInfo.email}`} className="mastering-contact-btn">
          <Mail size={20} />
          GET IN TOUCH
        </a>
      </div>
    </div>
  );
};

export default Mastering;
